<template>
  <div class="row u-align-items-center u-justify-content-flex-end">
    <div class="es-xs-12 es-md-6 es-lg-3 es-xl-3 u-margin-bottom-small-md-down">
      <ProjectSearch
        :value="filter.projectId"
        :label="$t('batteries.project')"
        no-label
        @input="SET_FILTER('projectId', $event)"
      ></ProjectSearch>
    </div>
    <div class="es-xs-12 es-md-6 es-lg-3 es-xl-3 u-margin-bottom-small-md-down">
      <user-search
        :value="filter.user"
        @input="SET_FILTER('user', $event)"
      ></user-search>
    </div>
    <div class="es-xs-12 es-md-6 es-lg-3 es-xl-3 u-margin-bottom-small-md-down">
      <div class="btn-group-container u-justify-content-flex-end">
        <Button
          group-item
          block
          v-tooltip="$t('filter.allTooltipMessage')"
          :variant="`${filter.type === null ? '' : 'light-'}${
            filter.type === null ? 'primary' : 'primary'
          }`"
          @click="SET_FILTER('type', null)"
        >
          {{ $t("filter.all") }}
        </Button>
        <Button
          v-for="(item, i) in batteryTypes"
          :key="i"
          group-item
          block
          :variant="`${
            filter.type === item.key ? item.variant : 'light-primary'
          }`"
          v-tooltip="$t(`filter.batteryTypeTooltipMessage`, { type: item.key })"
          @click="SET_FILTER('type', item.key)"
        >
          {{ $t(item.key) }}
        </Button>
      </div>
    </div>
    <div class="es-xs-12 es-md-6 es-lg-3 es-xl-3 u-margin-bottom-small-md-down">
      <div class="btn-group-container u-justify-content-flex-end">
        <Button
          group-item
          block
          v-tooltip="$t('filter.allTooltipMessage')"
          :variant="`${filter.isLocked === null ? '' : 'light-'}${
            filter.isLocked === null
              ? 'primary'
              : filter.isLocked
              ? 'danger'
              : 'success'
          }`"
          @click="SET_FILTER('isLocked', null)"
        >
          {{ $t("filter.all") }}
        </Button>
        <Button
          group-item
          block
          v-tooltip="$t('filter.isLockedTooltipMessage')"
          :variant="`${filter.isLocked ? '' : 'light-'}${
            filter.isLocked === null
              ? 'primary'
              : filter.isLocked
              ? 'danger'
              : 'success'
          }`"
          @click="SET_FILTER('isLocked', true)"
        >
          <i class="icofont-ui-lock"></i> {{ $t("common.lockedText") }}
        </Button>
        <Button
          group-item
          block
          v-tooltip="$t('filter.isUnLockedTooltipMessage')"
          @click="SET_FILTER('isLocked', false)"
          :variant="`${filter.isLocked === false ? '' : 'light-'}${
            filter.isLocked === null
              ? 'primary'
              : filter.isLocked
              ? 'danger'
              : 'success'
          }`"
        >
          <i class="icofont-ui-unlock"></i> {{ $t("common.unlockedText") }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "../Base/Button.vue";
import { getBatteryTypes } from "@/helpers/Battery/getBatteryType";
import UserSearch from "../Searches/UserSearch.vue";
import ProjectSearch from "../Searches/ProjectSearch.vue";
export default {
  components: {
    Button,
    ProjectSearch,
    UserSearch,
  },
  data() {
    return {
      filter: {
        isLocked: null,
        user: null,
        type: null,
        projectId: null,
      },
      batteryTypes: getBatteryTypes(),
    };
  },
  methods: {
    SET_FILTER(key, value) {
      this.filter[key] = value;
      this.$emit("change:filter", this.filter);
    },
    async GET_USER_FROM_QUERY() {
      const userId = this.$route.query.userId;
      if (userId) {
        this.filter.user = await this.$store.dispatch("getAdminById", {
          id: userId,
        });
      }
    },
    async GET_PROJECT_FROM_QUERY() {
      const projectId = this.$route.query.projectId;
      if (projectId) {
        this.filter.projectId = await this.$store.dispatch(
          "getMainProjectById",
          {
            id: projectId,
          }
        );
      }
    },
    async GET_FILTERS_FROM_QUERY() {
      await Promise.all([
        this.GET_USER_FROM_QUERY(),
        //  this.GET_PROJECT_FROM_QUERY(),
      ]);
      const type = this.$route.query.type;
      const isLocked = this.$route.query.isLocked;
      if (type) this.filter.type = type;

      if (isLocked === "true" || isLocked === "false")
        this.filter.isLocked = isLocked === "true" ? true : false;
      this.$emit("change:filter", this.filter);
    },
  },
  mounted() {
    this.GET_FILTERS_FROM_QUERY();
  },
};
</script>

<style></style>
